import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';

import createSagaMiddleware from 'redux-saga';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
// import injectTapEventPlugin from 'react-tap-event-plugin'
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import { green } from 'material-ui/styles/colors';

import { SnackbarProvider } from 'notistack';
import reducers from './store/reducers';
import App from './AppContainer';
import {
  getSkillsetOptionsWatcher,
  updateBusinessAttributesWatcher,
  updateNotificationSettingsWatcher,
  updateUserProfileWatcher,
} from './store/sagas';
const muiTheme = getMuiTheme({
  palette: {
    accent1Color: green,
  },
  tabs: {
    backgroundColor: green,
  },
});

const sagaMiddleware = createSagaMiddleware();

let composeEnhancers = compose;

if (process.env.NODE_ENV === 'development') {
  const composeWithDevToolsExtension =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  if (typeof composeWithDevToolsExtension === 'function') {
    composeEnhancers = composeWithDevToolsExtension;
  }
}

//  Create a redux store with the functions found in /reducers
const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(sagaMiddleware)),
);

sagaMiddleware.run(getSkillsetOptionsWatcher);
sagaMiddleware.run(updateBusinessAttributesWatcher);
sagaMiddleware.run(updateNotificationSettingsWatcher);
sagaMiddleware.run(updateUserProfileWatcher);

ReactDOM.render(
  <MuiThemeProvider muiTheme={muiTheme}>
    <SnackbarProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </SnackbarProvider>
  </MuiThemeProvider>,
  document.getElementById('root'),
);
